module.exports = __webpack_public_path__ + "cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cc.svg
// module id = 735
// module chunks = 0